<template>
<div class="chapter">
<div class="inner_page">
<section>
<h1 class="fmtitle2" epub:type="title"><span epub:type="pagebreak" id="page_xi" title="xi">MEDIEVAL NONSENSE</span></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_FM03.vue?02a759d0